"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ariaTabId = ariaTabId;
exports.ariaPanelId = ariaPanelId;
exports.default = TabGroup;
const react_1 = __importDefault(require("react"));
const events_1 = require("~/helpers/events");
require("./tab-group.scss");
function Tab({ label, selectedLabel, setSelectedLabel, TabTag, analytics }) {
    const blurAndSetLabel = react_1.default.useCallback((event) => {
        event.currentTarget.blur();
        setSelectedLabel(label);
    }, [setSelectedLabel, label]);
    const isSelected = react_1.default.useMemo(() => label === selectedLabel, [label, selectedLabel]);
    return (react_1.default.createElement(TabTag, { role: "tab", id: ariaTabId(label), "aria-controls": ariaPanelId(label), tabIndex: 0, "aria-selected": isSelected, onClick: blurAndSetLabel, onKeyDown: events_1.treatSpaceOrEnterAsClick, "data-analytics-link": analytics && !isSelected ? '' : undefined }, label));
}
function ariaTabId(label) {
    return `${label}-tab`;
}
function ariaPanelId(label) {
    return `${label}-panel`;
}
function TabGroup(_a) {
    var _b;
    var { labels, selectedLabel, setSelectedLabel, TabTag = 'div', children } = _a, props = __rest(_a, ["labels", "selectedLabel", "setSelectedLabel", "TabTag", "children"]);
    const analyticsNav = props['data-analytics-nav'];
    const listLabel = (_b = props.listLabel) !== null && _b !== void 0 ? _b : 'Tabs';
    return (react_1.default.createElement("div", { className: "tab-heading" },
        react_1.default.createElement("div", { className: "tabs-and-extras" },
            react_1.default.createElement("div", { role: "tablist", "aria-label": listLabel, "data-analytics-nav": analyticsNav }, labels.map((label) => react_1.default.createElement(Tab, { key: label, analytics: !!analyticsNav, label, selectedLabel, setSelectedLabel, TabTag }))),
            children),
        react_1.default.createElement("hr", { className: "tab-baseline" })));
}
